import { createSelector } from 'reselect';
import { IStore } from '../reducers';
import { IIntermediateTransaction } from '../reducers/transactions';

const getSuccessfulElrondTransactions = createSelector(
  (state: IStore) => state.transactions,
  (transactions: IIntermediateTransaction[]): IIntermediateTransaction[] =>
    transactions.filter(
      (tx) =>
        tx.klass === 'Elrond' &&
        tx.trading &&
        tx.transaction?.status === 'success'
    )
);

export { getSuccessfulElrondTransactions };
